<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        จัดการบทความ
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i>จัดการบทความ
          </a>
        </li>
        <!-- <li class="active">การจัดกลุ่มผู้ให้บริการ</li> -->
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header">
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="row">
                    <el-form
                      size="mini"
                      :label-position="label_position"
                      label-width="150px"
                      ref="ruleForm"
                      class="demo-ruleForm"
                    >
                      <div class="col-sm-12">
                        <div class="col-sm-6">
                          <el-form-item label="หัวข้อบทความ" prop="Connection_type">
                            <el-input placeholder="กรุณากรอกคำค้นหา" v-model="nameArticle"></el-input>
                          </el-form-item>
                        </div>
                        <div class="col-sm-3" style="margin-top:33px;">
                          <el-button type="primary" size="mini" @click="search(null)">ค้นหา</el-button>
                        </div>
                      </div>
                    </el-form>
                    <div class="pull-right box_add" v-if="user_permission.add">
                      <button @click="Add_article" class="btn btn-info btn_custom">
                        <i class="fa fa-plus"></i> เพิ่มบทความ
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="box-body">
                <div class="wrapper_typegroup">
                  <data-tables-server
                    @query-change="search"
                    :data="dataTable" 
                    :pagination-props="{ pageSizes: [5, 10, 15] }"
                    :current-page.sync="page"
                    :page-size.sync="pageSize"
                    :total="total"
                    >
                    <el-table-column type="index" :index="index_method" width="50"> </el-table-column>
                    <el-table-column prop="title_th" label="หัวข้อบทความ" width="250"></el-table-column>

                    <el-table-column prop="visible_status" label="การแสดงผล" width="200">
                      <template
                        slot-scope="scope"
                      >{{scope.row.visible_status === 0 ? "ไม่แสดง":"แสดง"}}</template>
                    </el-table-column>
                    <el-table-column sortable="custom" prop="created_at" label="วันที่สร้างข้อมูล" width="180">
                      <template
                        slot-scope="scope"
                      >{{moment(scope.row.created_at).add(543,'Y').format('DD/MM/YYYY')}}</template>
                    </el-table-column>
                    <el-table-column sortable="custom" prop="updated_at" label="วันที่อัปเดตข้อมูล" width="180">
                      <template
                        slot-scope="scope"
                      >{{ scope.row.updated_at ? moment(scope.row.updated_at).add(543,'Y').format('DD/MM/YYYY'):'ไม่มีการอัปเดต'}}</template>
                    </el-table-column>
                    <el-table-column sortable="custom" prop="updated_by_admin" label="อัปเดตโดย" width="180">
                      <template
                        slot-scope="scope"
                      >{{ scope.row.updated_by_admin ? scope.row.first_name + ' ' + scope.row.last_name :'ไม่มีการอัปเดต'}}</template>
                    </el-table-column>
                    <el-table-column label="จัดการ" align="center" width="170" fixed="right" v-if="user_permission.edit || user_permission.delete">
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="light" content="ดูข้อมูล" placement="top">
                          <el-button 
                          size="mini" 
                          type="success"
                          @click="handleView(scope.row)">
                            <i class="el-icon-view"></i>
                          </el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="light" content="แก้ไข" placement="top">
                          <el-button 
                          v-if="user_permission.edit"
                          size="mini" 
                          type="primary"
                          @click="handleEdit(scope.row)">
                            <i class="el-icon-edit"></i>
                          </el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="light" content="ลบ" placement="top">
                          <el-button
                          v-if="user_permission.delete"
                            class="custom-btn"
                            size="mini"
                            type="danger"
                            @click="handleDelete(scope.row.article_id)"
                          >
                            <i class="el-icon-delete-solid"></i>
                          </el-button>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </data-tables-server>
                  <el-dialog title="บทความ" :visible.sync="view_dialog" width="75%">
                    <div class="row">
                      <div class="box-img">
                          <img :src="dialog_data.thumbnail_image" />
                      </div>
                      <div class="text-group">
                        <div class="col-sm-3" align="right"><b>หัวข้อบทความ (ภาษาไทย)</b> : </div>
                        <div class="col-sm-9">{{ dialog_data.title_th }}</div>
                        <div class="col-sm-12"><br></div>
                      </div>
                      <div class="text-group">
                        <div class="col-sm-3" align="right"><b>หัวข้อบทความ (ภาษาอังกฤษ)</b> : </div>
                        <div class="col-sm-9">{{ dialog_data.title_en }}</div>
                        <div class="col-sm-12"><br></div>
                      </div>
                      <div class="text-group">
                        <div class="col-sm-3" align="right"><b>รายละเอียดเบื้องต้น (ภาษาไทย)</b> : </div>
                        <div class="col-sm-9">{{ dialog_data.short_description_th }}</div>
                        <div class="col-sm-12"><br></div>
                      </div>
                      <div class="text-group">
                        <div class="col-sm-3" align="right"><b>รายละเอียดเบื้องต้น (ภาษาอังกฤษ)</b> : </div>
                        <div class="col-sm-9">{{ dialog_data.short_description_en }}</div>
                        <div class="col-sm-12"><br></div>
                      </div>
                      <div class="text-group">
                        <div class="col-sm-3" align="right"><b>รายละเอียด (ภาษาไทย)</b> : </div>
                        <div class="col-sm-9"><span v-html="dialog_data.full_description_th"></span></div>
                        <div class="col-sm-12"><br></div>
                      </div>
                      <div class="text-group">
                        <div class="col-sm-3" align="right"><b>รายละเอียด (ภาษาอังกฤษ)</b> : </div>
                        <div class="col-sm-9"><span v-html="dialog_data.full_description_en"></span></div>
                        <div class="col-sm-12"><br></div>
                      </div>
                      <div class="text-group">
                        <div class="col-sm-3" align="right"><b>สถานะการแสดงผล</b> : </div>
                        <div class="col-sm-9">{{ dialog_data.visible_status === 0 ? 'ไม่แสดงผล' : 'แสดงผล' }}</div>
                        <div class="col-sm-12"><br></div>
                      </div>
                      <div class="text-group">
                        <div class="col-sm-3" align="right"><b>วันที่สร้างข้อมูล</b> : </div>
                        <div class="col-sm-9">{{ dialog_data.created_at ? moment(dialog_data.created_at).add(543, 'Y').format('DD/MM/YYYY') : '' }}</div>
                        <div class="col-sm-12"><br></div>
                      </div>
                      <div class="text-group">
                        <div class="col-sm-3" align="right"><b>วันอัปเดตข้อมูล</b> : </div>
                        <div class="col-sm-9">{{ dialog_data.updated_at ? moment(dialog_data.updated_at).add(543, 'Y').format('DD/MM/YYYY') : '' }}</div>
                        <div class="col-sm-12"><br></div>
                      </div>
                      <div class="text-group">
                        <div class="col-sm-3" align="right"><b>อัปเดตโดย</b> : </div>
                        <div class="col-sm-9">{{ dialog_data.updated_by_admin ? dialog_data.first_name+' '+dialog_data.last_name : '' }}</div>
                        <div class="col-sm-12"><br></div>
                      </div>
                    </div>
                  </el-dialog>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      user_permission : {
        add : false,
        edit : false,
        delete : false
      },
      nameArticle: "",
      label_position: "top",
      page: 1,
      pageSize: 5,
      view_dialog : false,
      dialog_data : {}
    };
  },
  computed: {
    ...mapState({
      dataTable: store => store.articleStore.dataTable,
      total: store => store.articleStore.total
    })
  },
  mounted() {
    const permission = JSON.parse(atob(this.$cookies.get("user_nbtc").permission)).Manage_article
    this.user_permission.add = permission.includes('add')
    this.user_permission.edit = permission.includes('edit')
    this.user_permission.delete = permission.includes('delete')
  },
  methods: {
    ...mapActions({
      searchArticle: "articleStore/searchArticle",
      remove: "articleStore/remove"
    }),
    search(queryInfo) {
      if (queryInfo == null) {
        this.page = 1
        queryInfo = {
          page: this.page,
          pageSize: this.pageSize,
          sort: null
        }
      }
      this.searchArticle({ nameArticle: this.nameArticle, queryInfo: queryInfo });
    },
    handleView(row){
      this.view_dialog = true
      this.dialog_data = row
    },
    handleEdit(row) {
      this.$router.push({
        name: "Manage_articleEdit",
        query: { article_id: row.article_id }
      });
    },
    handleDelete(id) {
      this.$confirm("ต้องการลบบทความนี้ ใช่หรือไม่", "แจ้งเตือน", {
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
        showCancelButton: true,
        type: "warning"
      })
        .then(() => {
          this.remove({article_id: id, admin_id: this.$cookies.get("user_nbtc").admin_id}).then(() => { this.search(null) })
        })
        .catch(() => {});
    },
    Add_article() {
      this.$router.push({ name: "Manage_article_add" });
    },
    index_method(index) {
      return index + (this.pageSize * (this.page - 1)) + 1
    }
  }
};
</script>
<style scoped>
 .text-group{
    word-break: break-word;
 }
</style>